import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

//services
import { get } from '../../services/http'
import routeListen from '../../services/routeListen';
import routeGen from '../../services/routeGen';

//interfaces
import {app as App} from '../../interfaces/Nav'
import { InitialAppState } from '../intialState/app';
import { SliceStatus } from '../../interfaces/Redux';



export interface AppState {
  app: App
  status: SliceStatus
  error?: string | undefined
}

const initialState: AppState = {
  app: InitialAppState,
  status: SliceStatus.initial,
  error: ''
}


export const appSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers(builder) {
    builder
      .addCase(fetchApp.pending, (state, action) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
        state.app = {...state.app, guid: routeListen.appGuid()}
      })
      .addCase(fetchApp.fulfilled, (state, action) => {
        if(action.payload) {
          state.status = SliceStatus.succeeded;
          // Add any fetched posts to the array
          state.app = action.payload;
          state.error = undefined;
        }
        
      })
      .addCase(fetchApp.rejected, (state, action) => {
        state.status = SliceStatus.failed
        state.error = action.error.message
      })
  }
})

export const fetchApp = createAsyncThunk('app/fetchApp', async (appGuid: string) => {
    // cache bust added, this will need to be removed in due course
    const { data } = await  get(`api/app/${appGuid}?language=${window.navigator.language}`)
      .catch((response) => {
        throw new Error(response.message);
      })

    return {
        fromCache : data?.fromCache,
        guid : data?.guid,
        homeUrl : data?.homeUrl,
        menu : buildRoutes(data?.mainMenu, appGuid),
        name : data?.name,
        settings : data?.settings,
        appBrandingLoaded : true,
        defaultContentTitle : data?.mainMenu.length ? data?.mainMenu[0].title : '',
        defaultContentId: data?.mainMenu.length ? data?.mainMenu[0].id : 0,
    }

});

function buildRoutes(items:any, appGuid: string){
    return items.map((item:any) => ({
        text: item.title,
        url: routeGen.buildPath('App', { appGuid, dataItemId: item.id }),
        id: item.id,
        type: item.type
    }));
}

// Export reset reducer
export const { reset } = appSlice.actions 

// Action creators are generated for each case reducer function
export default appSlice.reducer



